<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="_idContainer005">
<p class="ct" id="_idParaDest-1"><a class="calibre2" id="_idTextAnchor001"></a>Contents</p>
</div>
<div class="calibre1" id="_idContainer006">
<p class="toc-fmt-emt"><a class="calibre2" href="#/OEBPS/18_304_04_TOC#_idTextAnchor001">Contents</a></p>
<p class="toc-fmt-emt"><a class="calibre2" href="#/OEBPS/18_304_05_Intro#_idTextAnchor002">Introduction</a></p>
<p class="toc-fmt-emt"> </p>
<p class="toc-ct"><a class="calibre2" href="#/OEBPS/18_304_06_Ch01#_idTextAnchor003"><span class="toc_cn">1</span> Wake-Up Call</a></p>
<p class="toc-ct"><a class="calibre2" href="#/OEBPS/18_304_07_Ch02#_idTextAnchor005"><span class="toc_cn">2</span> Sweet Intentions</a></p>
<p class="toc-ct"><span class="calibre2" href="#/OEBPS/18_304_08_Ch03#_idTextAnchor007" title="Link target outside of Sample"><span class="toc_cn">3</span> A Secret Microbial Garden</span></p>
<p class="toc-ct"><span class="calibre2" href="#/OEBPS/18_304_09_Ch04#_idTextAnchor009" title="Link target outside of Sample"><span class="toc_cn">4</span> A Sweet Addiction</span></p>
<p class="toc-ct"><span class="calibre2" href="#/OEBPS/18_304_10_Ch05#_idTextAnchor011" title="Link target outside of Sample"><span class="toc_cn">5</span> Be Mindful of the Stress-Induced Sweet Tooth</span></p>
<p class="toc-ct"><span class="calibre2" href="#/OEBPS/18_304_11_Ch06#_idTextAnchor012" title="Link target outside of Sample"><span class="toc_cn">6</span> What Are Sugary Foods, Exactly?</span></p>
<p class="toc-ct"><span class="calibre2" href="#/OEBPS/18_304_12_Ch07#_idTextAnchor013" title="Link target outside of Sample"><span class="toc_cn">7</span> Wheat Gut</span></p>
<p class="toc-ct"><span class="calibre2" href="#/OEBPS/18_304_13_Ch08#_idTextAnchor014" title="Link target outside of Sample"><span class="toc_cn">8</span> Sugar Incognito</span></p>
<p class="toc-ct"><span class="calibre2" href="#/OEBPS/18_304_14_Ch09#_idTextAnchor017" title="Link target outside of Sample"><span class="toc_cn">9</span> Balanced Bellies</span></p>
<p class="toc-ct"><span class="calibre2" href="#/OEBPS/18_304_15_Ch10#_idTextAnchor019" title="Link target outside of Sample"><span class="toc_cn">10</span> Tuning In to the Garden Within</span></p>
<p class="toc-fmt-emt"> </p>
<p class="toc-fmt-emt"><span class="calibre2" href="#/OEBPS/18_304_16_Notes#_idTextAnchor022" title="Link target outside of Sample">Notes</span></p>
<p class="toc-fmt-emt"><span class="calibre2" href="#/OEBPS/18_304_17_Bib#_idTextAnchor023" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc-fmt-emt"><span class="calibre2" href="#/OEBPS/18_304_19_Aut#_idTextAnchor024" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 18_304_04_TOC.vue?3ea8a212